import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ExtraReportFields, SelectedFields } from './selected-fields.model';

@Injectable({
  providedIn: 'root'
})
export class ReportFieldOptionsService {

  private reportFields: BehaviorSubject<SelectedFields> = new BehaviorSubject<SelectedFields>(null);
  private reportFields$ = this.reportFields.asObservable();
  private hasRetrievedReportFields = {
    candidate: false,
    company: false,
    contact: false,
  };
  private selectedFields = new SelectedFields();

  constructor(
    private http: HttpClient
  ) {
  }

  saveFields(selectedFields: any): Observable<any> {
    this.clearSelectedFields();
    return this.http.post(`${environment.duplikitUrl}/meta/saveReportFields`, {selectedFields: selectedFields});
  }

  getSelectedReportFields(entity: string): Observable<any> {
    this.getReportFields(entity);
    return this.reportFields$.pipe(map(selectedFields => {
      if (selectedFields) {
        return selectedFields[entity];
      }
      return null;
    }));
  }

  getReportFields(entity: string): void {
    this.hasRetrievedReportFields[entity] = true;
    this.http.get(`${ environment.duplikitUrl }/meta/getSelectedReportFields?entity=${ entity }`)
        .subscribe((dataReceived: ExtraReportFields[]) => {
          this.selectedFields[entity] = dataReceived.map(field => field.fieldName);
          this.reportFields.next(this.selectedFields);
        });
  }

  getAvailableBHFields(entity: string): Observable<any> {
    return this.http.get(`${environment.duplikitUrl}/meta/getAvailableBHFields?entity=${entity}`);
  }

  private clearSelectedFields(): void {
    this.selectedFields = new SelectedFields();
    this.hasRetrievedReportFields = {
      candidate: false,
      company: false,
      contact: false,
    };
  }
}
